"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const format_1 = require("@/utils/format");
const Loading_1 = require("../layout/Loading");
const Card_1 = require("../dataCard/Card");
const SearchResultList = ({ searchResult, loading }) => {
    const path = {
        principalId: 'governance',
        accountId: 'account',
        txHash: 'transaction',
        blockHash: 'hash',
    };
    if (!loading && searchResult && searchResult.data && searchResult.totalResults > 0) {
        return (react_1.default.createElement(ListContainer, { sx: { gridColumn: 'span 12' } },
            react_1.default.createElement(TotalNumerResult, null,
                searchResult.data.length,
                " Results Found"),
            searchResult.data.map((e, i) => {
                return (react_1.default.createElement(Card_1.Card, { horizontal: true, isborder: true, key: `${e}-${i}`, bg: "bg", cardwidth: {
                        xs: 12,
                        sm: 12,
                        md: 6,
                        lg: 4,
                        xl: 3,
                    }, data: {
                        title: (0, format_1.formatAddress)(e.value),
                        url: `/${path[e.type]}/${e.value}`,
                    } },
                    react_1.default.createElement(Card_1.Card, { key: `${e}-${i}-${i}`, noPadding: true, cardwidth: {
                            xs: 6,
                            sm: 6,
                            md: 6,
                            lg: 4,
                            xl: 3,
                        }, data: {
                            location: e.type,
                        } }),
                    react_1.default.createElement(Card_1.Card, { key: `${e}-${i}-${i}-${i}`, noPadding: true, cardwidth: {
                            xs: 6,
                            sm: 6,
                            md: 6,
                            lg: 4,
                            xl: 3,
                        }, data: {
                            location: e.source,
                        } })));
            })));
    }
    else if (!loading && searchResult && searchResult.totalResults < 1) {
        return (react_1.default.createElement(NoFound, null,
            react_1.default.createElement("p", { color: "inherit" }, "No Match Found")));
    }
    else if (loading) {
        return (react_1.default.createElement(react_1.default.Fragment, null, Array.from({ length: 6 }).map((_, i) => (react_1.default.createElement(Loading_1.Loading, { style: { height: '100px', width: '100%', gridColumn: 'span 12' } })))));
    }
};
exports.default = SearchResultList;
const ListContainer = (0, styled_components_1.default)(material_1.Box) `
  background-color: ${(props) => props.theme.colors.bg};
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 20px;
`;
const ListItem = (0, styled_components_1.default)(material_1.Box) `
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 10px;
  grid-column: span 3;
  padding: 20px;
  background-color: ${(props) => props.theme.colors.altBg};
`;
const NoFound = (0, styled_components_1.default)(material_1.Box) `
  color: ${(props) => props.theme.colors.onBg};
  font-size: 3em;
  font-weight: 300;
  grid-column: span 12;
  width: 100%;
`;
const LoadingDataCard = (0, styled_components_1.default)('div') `
  margin-top: ${(props) => props.theme.spacing.margin.sm};
  height: 200px;
  padding-bottom: 20px;
  grid-column: span 3;
  ${(props) => props.theme.media.lg} {
    grid-column: span 6;
  }
  ${(props) => props.theme.media.md} {
    grid-column: span 6;
  }
  ${(props) => props.theme.media.sm} {
    grid-column: span 12;
  }
  ${(props) => props.theme.media.xs} {
    grid-column: span 12;
  }
`;
const TotalNumerResult = (0, styled_components_1.default)(material_1.Box) `
  background-color: ${(props) => props.theme.colors.bg};
  color: ${(props) => props.theme.colors.onBg};
  grid-column: span 12;
  padding-bottom: 15px;
`;
